import { getDrawingTool } from "./drawingTools";
import { timeToIndex } from "./timeIndex";

/**
 * @param {Array<{ time: number, price: number }>} points
 * @param {object} view - see createDrawings
 * @returns {Array<{ x: number, y: number }>} CSS px of the pane
 */
export const pointsToPixels = (points, { store, barDurationMs, timeScale, priceScale }) =>
  points.map(({ time, price }) => ({
    x: timeScale.indexToX(timeToIndex(time, store, barDurationMs)),
    y: priceScale.priceToY(price),
  }));

/**
 * Where a drawing is with the current scales.
 *
 * @param {{ type: string, points: Array<{ time: number, price: number }>, style: object }} item
 * @param {object} view - see createDrawings
 * @param {{ width: number, height: number }} pane - the price pane, CSS px
 * @returns {{
 *   item: object, tool: object, strokes: object[], fills: object[], labels: object[],
 *   handles: Array<{ x: number, y: number }>,
 * } | null} CSS px of the pane, see drawingShapeParts.js; null without bars or for an unknown tool
 */
export const resolveShape = (item, view, pane) => {
  const tool = getDrawingTool(item.type);

  if (!tool || !view.store.length) return null;

  const pixels = pointsToPixels(item.points, view);
  const { strokes, fills, labels = [] } = tool.shape(pixels, pane, item.style);

  return { item, tool, strokes, fills, labels, handles: tool.handles ? tool.handles(pixels, pane) : pixels };
};
